import { ModelFactory } from "../../ModelFactory";

export class DomainPrice {
  constructor(
    public readonly domain: string,
    public readonly price: number,
    public readonly transferPrice: number,
    public readonly isPremium: boolean,
  ) {
  }
}

class DomainPriceFactory extends ModelFactory<DomainPrice> {
  protected fromJson(json: any): DomainPrice {
    return new DomainPrice(
      json['domain'],
      json['price'],
      json['transfer_price'],
      json['is_premium'],
    );
  }
}
export const domainPriceFactory = new DomainPriceFactory();
